import { render, staticRenderFns } from "./ControlAssessmentScopeTable.vue?vue&type=template&id=3414f77c&"
import script from "./ControlAssessmentScopeTable.vue?vue&type=script&lang=js&"
export * from "./ControlAssessmentScopeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports